import React from "react";
import PropTypes from "prop-types";
import { TvButton, TvDiv, TvI, TvSmall } from "@trustvid/design-system";
import { getSmartCampaignSamplePrompts } from "../constants/smartCampaignPromptGuide";

const SAMPLE_PROMPT_ICONS = {
  "pdf-brochure-both": "fa-file-pdf-o",
  "uploads-styling": "fa-paint-brush",
  "prompt-only-promo": "fa-align-left",
  "personalized-pip": "fa-user",
  "vertical-reel": "fa-mobile",
  "silent-promo": "fa-volume-off",
};

const AiCampaignSamplePrompts = ({
  activeMode = "empty",
  selectedSamplePromptId = null,
  onSelectPrompt = () => {},
  disabled = false,
  hasFiles = false,
  appearance = "buttons",
}) => {
  const samples = getSmartCampaignSamplePrompts(activeMode);

  const chips = appearance === "chips";

  return (
    <TvDiv className="mb-3" data-testid="ai-campaign-sample-prompts">
      <TvSmall className="text-muted fw-semibold d-block mb-2">
        {chips ? "Quick start" : "Sample prompts"}
      </TvSmall>
      {!chips && activeMode === "prompt-only" && !hasFiles ? (
        <TvSmall className="text-muted d-block mb-2">
          Brief-only works — AI may add stock visuals and music. Attach files to use your own media.
        </TvSmall>
      ) : null}
      <TvDiv className="d-flex flex-wrap gap-2">
        {samples.map((sample) => {
          const isSelected = selectedSamplePromptId === sample.id;
          return (
            <TvButton
              key={sample.id}
              type="button"
              color={isSelected ? "primary" : chips ? "light" : "outline-secondary"}
              size="sm"
              className={`text-start ${chips ? "rounded-pill border px-3" : ""} ${isSelected ? "fw-semibold" : ""}`}
              data-testid={`ai-campaign-sample-prompt-${sample.id}`}
              data-selected={isSelected ? "true" : "false"}
              aria-pressed={isSelected}
              disabled={disabled}
              onClick={() => onSelectPrompt(sample)}
            >
              {chips && SAMPLE_PROMPT_ICONS[sample.id] ? (
                <TvI className={`fa ${SAMPLE_PROMPT_ICONS[sample.id]} me-2`} aria-hidden="true" />
              ) : null}
              {sample.label}
            </TvButton>
          );
        })}
      </TvDiv>
    </TvDiv>
  );
};

AiCampaignSamplePrompts.propTypes = {
  activeMode: PropTypes.oneOf(["empty", "uploads-only", "prompt-only", "uploads-and-prompt"]),
  selectedSamplePromptId: PropTypes.string,
  onSelectPrompt: PropTypes.func,
  disabled: PropTypes.bool,
  hasFiles: PropTypes.bool,
  appearance: PropTypes.oneOf(["buttons", "chips"]),
};

export default AiCampaignSamplePrompts;
